<template>
<div class="container">
    <PauseModal v-if="modal_pause" @restart="
            modal_pause = !modal_pause;
            reset=true;
            play=true;
            playMusic = !playMusic;
        " @closeModal="
            modal_pause = !modal_pause;
            reset=false;
            play=false;
        " @resume="
            modal_pause = !modal_pause;
            reset=false;
            play=true;
            playMusic = !playMusic;
        " />
    <AlertModal v-if="alert_modal" @closeModal="alert_modal=!alert_modal" />


        <div class="editmelody tamanhoicon" @click="$emit('reDo')">
            <img :src="require('@/assets/buttons/newbuttons/melody/back.svg')" />
        </div>
        <div class="complete-melody tamanhoicon" @click="finish">
            <img :src="require('@/assets/buttons/newbuttons/melody/submit.svg')" />
        </div>
        <div id="menu_play" class="tamanhoicon" @click="play_pause">
            <img :src="require('@/assets/buttons/newbuttons/melody/pause.svg')" v-if="play" />
            <img :src="require('@/assets/buttons/newbuttons/melody/play.svg')" v-else />
        </div>


    <div>
        <div v-if="current_phrase > 1" @click="back_phrase" id="back" class="tamanhoicon">
            <img :src="require('@/assets/buttons/newbuttons/melody/seta_esq.svg')" />
        </div>
        <div v-else id="back" class="tamanhoicon">
            <img :src="require('@/assets/buttons/newbuttons/melody/seta_esq_disable.svg')" />
        </div>
        <div v-for="(phrase, i) in phrases_g" :key="'Phrase-' + i" :id="'Phrase-' + i">
            <PhraseDisplay v-if="i == current_phrase && phrases_options[i] !== undefined" :disabled="play" :key="'PD-' + i" :number="i" :phrase="phrase" :options="phrases_options[i]" @altered_option="alter_options" />
        </div>
        <div v-if="current_phrase == Object.keys(phrases_g).length" id="forward" class="tamanhoicon">
            <img :src="require('@/assets/buttons/newbuttons/melody/seta_drt_disable.svg')" />
        </div>
        <div v-else @click="next_phrase" id="forward" class="tamanhoicon">
            <img :src="require('@/assets/buttons/newbuttons/melody/seta_drt.svg')" />
        </div>
    </div>

    <canvas :id="'canvas-score'" class="canvas-melody"></canvas>
    <MidiPlayer :midi="midi" :playMidi="playMusic" :velocity="velocity" @finishedPlaying="play = false;" :reset="reset"></MidiPlayer>
</div>
</template>

<script>
import MidiPlayer from "../General/MidiPlayer.vue";
import PauseModal from "@/components/MelodyGame/PauseModal.vue";
import AlertModal from "@/components/MelodyGame/Alert.vue";
import PhraseDisplay from "@/components/MelodyGame/PhraseDisplay.vue"

export default {
    name: "Score",
    emits: ['reDo', 'backToMenu', 'openSettings', 'restart', 'onFinish'],
    components: {
        MidiPlayer,
        PauseModal,
        AlertModal,
        PhraseDisplay
    },
    created() {
        window.addEventListener("resize", this.resize);
        this.reset_choices();
    },
    mounted() {
        this.current_phrase = 1;

        console.log(this.saved_options);

        if (!this.saved_options
            || Object.keys(this.saved_options).length !== 0
            || Object.getPrototypeOf(this.saved_options) !== Object.prototype) {
            this.phrases_options = this.saved_options;
        }
        this.draw_phrase(this.current_phrase);
    },
    data() {
        return {
            phrases: [],
            phrases_options: {},
            n_phrases: 0,

            current_phrase: 0,

            modal_pause: false,
            congrats_modal: false,
            alert_modal: false,

            play: false,
            playMusic: false,
            midi: "",
            velocity: 1.0,
            reset: false
        };
    },
    props: {
        point_coordinates: Object,
        phrases_g: Object,
        saved_options: Object,
    },
    watch: {
        phrases_g: {
            deep: true,
            handler: function (val, oldVal) {
                console.log('Prop changed: ', val, ' | was: ', oldVal);
                for (let phr in val) {
                    if (this.phrases_options[phr] === undefined) {
                        this.reset_phrase_choices(phr);
                    }
                }
            }
        }
    },
    methods: {
        play_pause() {
            if (this.play) {
                this.popup_pausa();
            } else {
                this.play_current_phrase();
            }
        },
        popup_pausa() {
            this.modal_pause = !this.modal_pause;
            this.play = false;
            this.playMusic = !this.playMusic;
        },
        finish() {
            let complete_flag = true;
            let complete_music = [];

            for (let phr in this.phrases_g) {

                for (let b_m in this.phrases_g[phr]["different_rhythm_beats"]) {
                    if (
                        this.phrases_options[phr][
                            this.phrases_g[phr]["different_rhythm_beats"][b_m]
                        ] == ""
                    ) {
                        complete_flag = false;
                        break;
                    }
                }

                for (let beat in this.phrases_g[phr]['alt_0']) {
                    console.log(this.phrases_g[phr]["different_rhythm_beats"]);
                    console.log(this.phrases_options[phr][beat]);

                    if (this.phrases_g[phr]["different_rhythm_beats"].includes(parseInt(beat))) {
                        let current_alternative = this.phrases_options[phr][beat];
                        console.log(current_alternative);
                        complete_music.push(this.phrases_g[phr][current_alternative][beat]);
                    } else {
                        complete_music.push(this.phrases_g[phr]['alt_0'][beat]);
                    }
                }
            }
            if (complete_flag) {
                this.congrats_modal = true;
                this.$emit("onFinish", {'music': complete_music, 'options': this.phrases_options});
            } else {
                this.alert_modal = true;
            }
        },
        reset_choices() {
            for (let phr in this.phrases_g) {
                console.log(phr);
                this.reset_phrase_choices(phr);
            }
            this.congrats_modal = false;
        },
        reset_phrase_choices(phr) {
            this.phrases_options[phr] = {};
            for (let b_m in this.phrases_g[phr]["different_rhythm_beats"]) {
                this.phrases_options[phr][
                    this.phrases_g[phr]["different_rhythm_beats"][b_m.toString()]
                ] = "";
            }
        },
        next_phrase() {
            if (this.current_phrase < Object.keys(this.phrases_g).length) {
                this.current_phrase += 1;
            }
            this.draw_phrase(this.current_phrase);
        },
        back_phrase() {
            if (this.current_phrase > 1) {
                this.current_phrase -= 1;
            }
            this.draw_phrase(this.current_phrase);
        },
        alter_options(phr_opt) {
            this.phrases_options[phr_opt[0]][phr_opt[1]] = phr_opt[2];
        },
        clean_phrase() {
            let canvas = document.getElementById("canvas-score");
            if (canvas !== null) {
                let ctx = canvas.getContext("2d");
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                let w = canvas.width;
                canvas.width = 1;
                canvas.width = w;
            }
        },
        calculateCurves(phr) {
            let beats = Object.values(this.phrases_g[phr]['alt_0']);
            console.log(beats);
            let curve = beats.map((e) => {
                if (e[0][3] != 0) return e[0][3];
                let poss = e.map((e1) => {
                    return e1[3]
                });
                let non_zero = poss.find((value) => value !== 0);
                if (non_zero !== undefined) return non_zero;
                return 2;
            });
            return this.calculateCurveFromPoints(curve);
        },
        calculateCurveFromPoints(points) {
            let width = window.innerWidth;
            let height = window.innerHeight;

            let div_w = width / (points.length + 1);
            let div_h = height / 8;

            let line_3 = [];

            line_3.push({
                x: 0,
                y: height / 2.0,
            });

            let last_x = 0;
            for (let j = 0; j < points.length; j++) {
                last_x += div_w;

                let num = points[j];
                let y = num * div_h;
                if (num == 1) {
                    y -= div_h / 6.0;
                }
                if (num == 3) {
                    y += div_h / 6.0;
                }

                line_3.push({
                    x: last_x,
                    y: y,
                });
            }

            line_3.push({
                x: last_x + div_w,
                y: height / 2.0,
            });

            let maxArray = Math.max.apply(null, line_3.map(function (el) {
                return el.y + 1.75 * div_h
            }));
            let minArray = Math.min.apply(null, line_3.map(function (el) {
                return el.y - 0.25 * div_h
            }));
            if (maxArray > window.innerHeight) {
                line_3 = line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y - (window.innerHeight - maxArray) - 5
                    }
                });
            } else if (minArray < window.innerHeight / 9.0) {
                line_3 = line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + (window.innerHeight / 9.0)
                    }
                });
            }

            return {
                line_1: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + 0.25 * div_h,
                    };
                }),
                line_2: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + div_h,
                    };
                }),
                line_3: line_3.map(function (el) {
                    return {
                        x: el.x,
                        y: el.y + 1.75 * div_h,
                    };
                }),
            };
        },
        draw_phrase(i) {

            this.clean_phrase();

            let canvas = document.getElementById("canvas-score");
            let cv_rect = canvas.getBoundingClientRect();
            canvas.width = cv_rect.width;
            canvas.height = cv_rect.height;

            let ctx = canvas.getContext("2d");

            let coordinates = [];

            if (this.phrases[i - 1] === undefined) {
                coordinates = this.calculateCurves(i);
                this.phrases[i - 1] = { 'coord': coordinates };
            } else {
                coordinates = this.phrases[i - 1]['coord'];
            }

            for (let line in coordinates) {
                this.draw_curve_aux(ctx, coordinates[line], 1.5, 'white', 3);
            }

            setTimeout(() => {
                this.adjust_positions(i);
            }, 0.05);
        },
        adjust_positions(i) {

            let coordinates = this.phrases[i - 1]["coord"];
            let nb = Object.keys(this.phrases_g[i]['alt_0']).length;
            let coord = this.get_points_in_bezier_curve(coordinates['line_1'], 1.5, nb);
            let bmw = (coord[coord.length - 1].x - coord[0].x) / (nb);

            for (let j = 0; j < coord.length; j++) {

                let cd = coord[j];
                let num = Object.keys(this.phrases_g[i]['alt_0'])[j];
                let id = "Beat-" + i + '-' + num.toString();
                let div = document.getElementById(id);

                if (div != null) {
                    div.style.position = "absolute";
                    div.style.left = cd.x - 0.5 * bmw + 'px';

                    div.style.top = cd.y + 'px';
                    div.style.width = 1.5*bmw + 'px';

                    console.log(id);
                    console.log(cd.y);
                }
            }
        },
        play_current_phrase() {

            let phrase = Object.assign({},
                this.phrases_g[this.current_phrase]["alt_0"]
            );

            let beats_to_substitute =
                this.phrases_g[this.current_phrase]["different_rhythm_beats"];

            for (let k in beats_to_substitute) {
                let beat = beats_to_substitute[k];
                let option_beat =
                    this.phrases_options[this.current_phrase][beat.toString()];

                if (option_beat === "") {
                    phrase[beat] = new Proxy({
                        0: [5, "R", 1]
                    }, {});
                } else {
                    phrase[beat] = this.phrases_g[this.current_phrase][option_beat][beat];
                }
            }

            let notes = [];
            for (let b in Object.keys(phrase)) {
                let beat = Object.keys(phrase)[b];
                for (let note in phrase[beat]) {
                    let dur = phrase[beat][note][2];
                    if (dur == 1) {
                        dur = this.phrases_g[this.current_phrase]["whole_duration"];
                    }
                    notes.push([phrase[beat][note][1], dur]);
                }
            }
            this.midi = {
                notes: notes,
                whole_duration: this.phrases_g[this.current_phrase]["whole_duration"],
                instrument: "cowbell",
            };

            this.play = true;
            this.playMusic = !this.playMusic;
        },
        resize() {
            this.calculate_points();
            this.draw_phrase(this.current_phrase);
        }
    },
};
</script>

<style>
.container {
    width: 100%;
    height: 100%;
    position: absolute;
}

.canvas-melody {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
}

.complete-melody {
position: absolute;
    right: 4%;
    bottom: 25%;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
    z-index: 10;
}

.editmelody {
    position: fixed;
    left: 4%;
    top: 25%;
    z-index: 10;
   filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
}

.play-melody-game {
  position: absolute;
    width: 100%;
    display: flex;
    bottom: 7%;
    justify-content: center;
    filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));
    z-index: 10;
}

</style>
